import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import cl from './Contacts.module.css';

const Contacts = (props) => {
  const position = props.coordinates?.split(', ') || [48.865634, 2.417106];

  return (
    <section className={cl.contact}>
      <img
        className={cl.big_image}
        src="https://www.iai.co.il/drupal/sites/default/files/2022-02/Contact%20us.jpg"
      />
      {/* <div className={cl.profile}>
        <div className={cl.info}>
          <h1>Contact us</h1>
        </div>
      </div> */}
      <div className={cl.main}>
        <div>
          <p>
            Si vous avez des questions ou des préoccupations, n'hésitez pas à
            Contactez-nous.
          </p>
          <p>Nous aimerions avoir de vos nouvelles, contactez-nous au :</p>
          <div className={cl.contacts}>
            <p>
              Email:{' '}
              <a href={'mailto: soutien@' + props.domain}>
                soutien@{props.domain}
              </a>
            </p>
            <p>{props.shopName} Groupe</p>
            <p>{props.address}</p>
            <p>
              Tel: <a href="tel:+33149720600">+33 1 49 72 06 00</a>
            </p>
          </div>
        </div>
        <MapContainer
          center={position}
          zoom={12}
          scrollWheelZoom={false}
          style={{ height: '450px', width: '700px', margin: '1rem auto' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} />
        </MapContainer>
      </div>
    </section>
  );
};

export default Contacts;
